import { set } from '@/utils/vuex'

export default {
  setUser: set('user')
}
